import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { UseSelectStateChange } from 'downshift';

import { DropdownItem } from '@app/components';
import { useQueryParams } from '@app/hooks';
import { generateRouteParams, getSafeInteger } from '@app/utils';
import { pageDefaults } from '@app/constants';

interface UsePaginatedItemsPerPageProps {
  isUrlBased?: boolean;
}

export const usePaginatedItemsPerPage = ({
  isUrlBased = true,
}: UsePaginatedItemsPerPageProps = {}) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const {
    pageNumber = pageDefaults.pageNumber,
    recordsPerPage = pageDefaults.recordsPerPage,
    sortDirection,
  } = useQueryParams();
  const location = useLocation();

  const updateUrl = (
    updatedPageNumber = Number(pageNumber),
    updatedRecordsPerPage = Number(recordsPerPage)
  ) => {
    navigate(
      generateRouteParams({
        pathname: location.pathname,
        query: {
          ...(sortDirection && { sortDirection: `${sortDirection}` }),
          pageNumber: updatedPageNumber,
          recordsPerPage: updatedRecordsPerPage,
        },
      })
    );
  };

  const handlePageChange = (newPageNumber: number) => {
    if (isUrlBased) {
      updateUrl(newPageNumber);
    } else {
      setCurrentPage(newPageNumber);
    }
  };

  const handleTitlePerPageUpdate = (
    option: UseSelectStateChange<DropdownItem>
  ) => {
    if (option.selectedItem) {
      const updatedRecordsPerPage = option.selectedItem.value;

      updateUrl(1, updatedRecordsPerPage);
    }
  };

  return {
    pageNumber: isUrlBased
      ? getSafeInteger(pageNumber, pageDefaults.pageNumber)
      : currentPage,
    recordsPerPage: getSafeInteger(recordsPerPage, pageDefaults.pageNumber),
    handlePageChange,
    handleTitlePerPageUpdate,
  };
};
